<template>
  <!-- 切换sop模板 -->
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_SelectTheSopTemplateToApplyToTheBusiness')"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <cargo-ag-grid
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :show-side-bar="false"
      :row-data="rowData"
      style="width:100%;height:350px;"
    />
    <span slot="footer">
      <el-button no="confirm" type="primary" @click="changeJobSopTemplate">{{ $t('common.btn.confirm') }}</el-button>
      <el-button
        no="close"
        @click="innerVisible=false"
      >{{ $t('common.btn.close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { queryTenantAllSopTemplate } from '@/api/sysManage/baseConfig/businessManage'
import { getLoading } from '@/utils/utilBaseElement'
import { batchChangeJobSopTemplate } from '@/api/trackingService'

export default {
  name: 'ChangeSopTemplateDialog',
  components: {},
  props: {
    visible: { type: Boolean, required: true },
    lob: { type: String, required: true },
    jobList: { type: Array, required: true }
  },
  data() {
    return {
      selectSopTemplate: null,
      sopTemplates: null,
      isZh: this.$store.getters.language === 'zh',
      innerVisible: false,
      gridParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        // 选中
        onRowClicked: (event) => {
          this.selectSopTemplate = event.data
        },
        context: {
          componentParent: this
        }
      }
    }
  },
  computed: {
    rowData() {
      return (!this.sopTemplates || !this.lob) ? [] : this.sopTemplates.filter(item => (item.lob === this.lob && item.sopStatus))
    },
    changeSopTitle() {
      let lobName = ''
      for (const lob of Array.from(SystemConstants.LOBS)) {
        if (lob.code === this.lob) {
          lobName = this.isZh ? lob.chineseName : lob.englishName
        }
      }
      return lobName + this.$t('CargoMsg.Cargo_SopTemplate')
    },
    columnDefs() {
      return [
        { headerName: this.changeSopTitle, field: 'templateName', colId: 'templateName', flex: 1
        }
      ]
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (!this.sopTemplates) {
        queryTenantAllSopTemplate().then(res => {
          this.sopTemplates = res.data
        })
      }
    },
    changeJobSopTemplate() {
      const selectSopTemplate = this.selectSopTemplate
      if (!selectSopTemplate || !selectSopTemplate.uuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectSOPTemplateForChange'))
        return
      }
      const jobKeys = []
      // 获取需要变更的业务uuidList
      for (const job of this.jobList) {
        // 于当前业务sop模板一致，不变更
        if (job.trackingTemplateUuid !== selectSopTemplate.uuid) {
          jobKeys.push(job.uuid)
        }
      }
      // 判断是否有需要变更的
      if (!jobKeys || jobKeys.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectOtherSOPTemplate'))
        return
      }
      this.loading = getLoading()
      batchChangeJobSopTemplate(jobKeys, { trackingTemplateKey: selectSopTemplate.uuid }).then(res => {
        this.loading.close()
        this.$message.success(this.$t('SeaExport.UpdateSuccess'))
        this.innerVisible = false
        this.$emit('reload')
      }).catch(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style scoped>

</style>
